import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Checkbox,
  ListItemText,
  DialogContentText,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
});
class SplitShipment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProducts: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange = value => {
    const selectedProducts = this.state.selectedProducts;
    if (selectedProducts.indexOf(value) >= 0) {
      delete selectedProducts[selectedProducts.indexOf(value)];
    } else {
      selectedProducts.push(value);
    }

    this.setState({ selectedProducts: selectedProducts.filter(item => !!item) });
  };

  render() {
    const { order, classes, handleClose, handleSubmit } = this.props;
    const { selectedProducts } = this.state;
    return (
      <Dialog
        open
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Split shipment - ({order.shipmentRef})</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Select products to split:
          </DialogContentText>
          {order &&
            order.products.map(product => (
              <MenuItem
                key={product.orderLineId}
                onClick={() => this.handleChange(product.orderLineId)}
              >
                <Checkbox checked={selectedProducts.indexOf(product.orderLineId) >= 0} />
                <ListItemText
                  primary={`${product.productName} ${product.size} ${product.colour}`}
                />
              </MenuItem>
            ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleSubmit(order, selectedProducts)}
            className={classes.button}
            disabled={
              selectedProducts.length === 0 || selectedProducts.length === order.products.length
            }
          >
            Submit
          </Button>
          <Button onClick={() => handleClose()} className={classes.button}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

SplitShipment.propTypes = {
  classes: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
export default withStyles(styles)(SplitShipment);



// WEBPACK FOOTER //
// ./src/components/orders/SplitShipment.js